import React, { useState } from "react";
import {
  DueDateDayTypes,
  DueDateOperators,
  DueDateReferenceDates,
  TaskConfigParamOptions,
  TaskFunctionParams,
} from "@eave/shared/types/api";

import getHandlers from "web_modules/shared/FormHelpers/eventHandlers";

import {
  TextInput,
  RadioButtonGroup,
  RadioButton,
  Select,
  SelectItem,
} from "carbon-components-react";
import Validations from "web_modules/shared/FormHelpers/validation";

import { dateParametersToDisplayString } from "../helpers";

const styles = require("./styles.module.scss");

interface EditTaskClauseDateParametersProps {
  options: TaskConfigParamOptions;
  formState: TaskFunctionParams;
  setFormState: Function;
  fieldName?: string;
}

const EditTaskClauseDateParameters: React.FC<EditTaskClauseDateParametersProps> = ({
  options,
  formState,
  setFormState,
  fieldName,
}) => {
  const [invalidFields, setInvalidFields] = useState([]);

  const { handleIntegerInputChange, handleRadioChange, handleSelectChange } = getHandlers(
    formState,
    setFormState,
    invalidFields,
    setInvalidFields,
  );

  return (
    <div className={styles.wrapper}>
      <p>
        <strong>Currently:&nbsp;</strong>
        {dateParametersToDisplayString(formState || {})}
      </p>
      <div style={{ marginBottom: "2rem" }} />
      <Select
        id={`${fieldName}-due-date-reference-dates`}
        name="reference_dates"
        value={(formState && formState.reference_date) || ""}
        invalid={invalidFields.includes("reference_date")}
        invalidText="A valid value is required"
        labelText="Reference date *"
        onBlur={e => handleSelectChange(e, "reference_date", [Validations.IsValid])}
        onChange={e => handleSelectChange(e, "reference_date", [Validations.IsValid])}
        style={{ minWidth: "270px" }}
        size="sm"
      >
        <SelectItem text="Select a reference date" value="" />
        {options.due_date_reference_dates.map(dayType => (
          <SelectItem key={dayType} text={DueDateReferenceDates[dayType]} value={dayType} />
        ))}
      </Select>
      <div style={{ marginBottom: "10px" }} />
      <Select
        id="task-function-name"
        name="date_comparison"
        value={(formState && formState.date_comparison) || ""}
        invalid={invalidFields.includes("date_comparison")}
        invalidText="A valid date comparison operator is required"
        labelText=""
        onChange={e => handleSelectChange(e, "date_comparison")}
        size="sm"
      >
        <SelectItem text="Select an operator" value="" />
        {options.date_comparison_operators.map(op => (
          <SelectItem key={op} text={op} value={op} />
        ))}
      </Select>
      <div style={{ marginBottom: "10px" }} />

      {formState &&
        formState.date_comparison &&
        !(formState.date_comparison === "null" || formState.date_comparison === "notNull") && (
          <>
            <TextInput
              id={`${fieldName}-task-due-date-name`}
              name="due-date-name"
              value={(formState && formState.days) || ""}
              labelText="Number of Days *"
              placeholder="15"
              type="text"
              invalid={invalidFields.includes("days")}
              invalidText="Enter a valid number"
              onBlur={e => handleIntegerInputChange(e, "days", [Validations.IsNumber])}
              onChange={e => handleIntegerInputChange(e, "days", [])}
              size="xl"
            />
            <div style={{ marginBottom: "10px" }} />
            <Select
              id={`${fieldName}-due-date-type-of-day`}
              name="type_of_day"
              value={(formState && formState.type_of_day) || ""}
              invalid={invalidFields.includes("type_of_day")}
              invalidText="A valid value is required"
              labelText="Type of day *"
              onBlur={e => handleSelectChange(e, "type_of_day", [])}
              onChange={e => handleSelectChange(e, "type_of_day", [])}
              style={{ minWidth: "270px" }}
              size="sm"
            >
              <SelectItem text="Select a day type" value="" />
              {options.due_date_day_types.map(dayType => (
                <SelectItem key={dayType} text={DueDateDayTypes[dayType]} value={dayType} />
              ))}
            </Select>
            <div style={{ marginBottom: "10px" }} />
            <RadioButtonGroup
              id={`${fieldName}-due-date-before-or-after`}
              valueSelected={formState && formState.before_or_after}
              labelPosition="right"
              labelText="Before or after?"
              name={`${fieldName}-before_or_after`}
              invalid={invalidFields.includes("before_or_after")}
              onChange={before_or_after =>
                handleRadioChange(before_or_after, "before_or_after", [])
              }
              orientation="horizontal"
              className={styles.radioButtonWrapper}
              size="sm"
            >
              {options.due_date_operators.map(before_or_after => (
                <RadioButton
                  id={`${fieldName}-radio-${before_or_after}`}
                  key={`radio-${before_or_after}`}
                  labelText={DueDateOperators[before_or_after]}
                  value={before_or_after}
                />
              ))}
            </RadioButtonGroup>
            <div style={{ marginBottom: "16px" }} />
            <Select
              id={`${fieldName}-due-date-reference-dates`}
              name="reference_dates"
              value={(formState && formState.other_reference_date) || ""}
              invalid={invalidFields.includes("other_reference_date")}
              invalidText="A valid value is required"
              labelText="Reference date *"
              onBlur={e => handleSelectChange(e, "other_reference_date", [])}
              onChange={e => handleSelectChange(e, "other_reference_date", [])}
              style={{ minWidth: "270px" }}
              size="sm"
            >
              <SelectItem text="Select a reference date" value="" />
              {options.due_date_reference_dates.map(dayType => (
                <SelectItem key={dayType} text={DueDateReferenceDates[dayType]} value={dayType} />
              ))}
            </Select>
            <div style={{ marginBottom: "10px" }} />
          </>
        )}
    </div>
  );
};

export default EditTaskClauseDateParameters;
